import { ErrorBlock } from '@/components/common/ErrorBlock'
import { InputMenu } from '@/components/common/Input'
import { JumpHeader } from '@/components/common/JumpHeader'
import { LinkHash } from '@/components/common/Link'
import { Icon } from '@/components/icons/Icon'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { usePage } from '@/components/providers/PageProvider'
import { useScrollspyActiveSlug } from '@/components/providers/ScrollspyProvider'
import { isIconType } from '@/defs/icon'

import styles from './GuideStickyHeader.module.scss'

export const GuideStickyHeader = () => {
  const activeSlug = useScrollspyActiveSlug()
  const { page } = usePage()
  const article = page?.article
  const guide = article?.guide

  if (!article) return <ErrorBlock />

  const menuItems = guide?.flatMap((group) => [
    {
      isHeading: true,
      label: (
        <span className={styles.sectionHeading}>
          <IconWithLabel iconBefore={isIconType(group.icon) && group.icon}>{group.chapter}</IconWithLabel>
        </span>
      ),
    },
    ...group.sections.map(({ label, slug }) => ({
      label: <LinkHash hash={slug}>{label}</LinkHash>,
    })),
  ])

  const jumpHeaderItems =
    guide?.flatMap((group) => [
      { label: group.chapter, variant: 'bold' as const },
      ...group.sections.map(({ label, slug }) => ({ label, slug })),
    ]) || []

  if (!menuItems || !jumpHeaderItems.length) return null

  return (
    <div className={styles.container}>
      <JumpHeader activeSlug={activeSlug} items={jumpHeaderItems} offset={16} />
      <div className={styles.buttonWrap}>
        <InputMenu aria-label='Jump to Section' options={menuItems}>
          <div className={styles.button}>
            <Icon name='caretDown' />
          </div>
        </InputMenu>
      </div>
    </div>
  )
}
